import Vuex from 'vuex'

import { createPersistedState } from '../plugins'

class Store {
  constructor({
    modules = {},
    mutations = {},
    actions = {},
    plugins = [],
    persisted = false,
    persistedOptions = { key: 'vuex', paths: [], expirationTime: 60, isAsyncStorage: false },
  }) {
    this.modules = modules
    this.mutations = mutations
    this.actions = actions
    this.plugins = plugins
    this.persisted = persisted
    this.persistedOptions = persistedOptions

    if (this.persisted) {
      this.plugins.push(this.initializePersistancePlugin())
    }
  }

  async getInitialState() {
    let state = {}

    if (this.persisted) {
      if (this.persistedOptions.isAsyncStorage) {
        state = await this.persistedOptions.storage.getState()
      }

      state = this.persistedOptions.storage.getState()
    }

    const persistedData = await state
    if (persistedData && persistedData.expires < Date.now()) {
      state = {}
    }

    return state
  }

  isModulePersisted(moduleKey) {
    return this.persisted && this.persistedOptions.paths.includes(moduleKey)
  }

  getRequiredModules() {
    if (this.persisted) {
      return Object.keys(this.modules).reduce((acc, key) => {
        if (this.isModulePersisted(key)) {
          return acc
        }
        return { ...acc, [key]: this.modules[key] }
      }, {})
    }

    return this.modules
  }

  initializePersistancePlugin() {
    const { key, paths, isAsyncStorage, ...restOptions } = this.persistedOptions

    return createPersistedState({
      key,
      paths,
      ...restOptions,
    })
  }

  async initialize() {
    const { state } = (await this.getInitialState()) || {}

    const store = new Vuex.Store({
      strict: true,
      modules: this.getRequiredModules(),
      state,
      mutations: this.mutations,
      actions: this.actions,
      plugins: this.plugins,
    })

    Object.keys(this.modules).forEach((key) => {
      if (this.isModulePersisted(key)) {
        store.registerModule(key, this.modules[key], { preserveState: !!store.state[key] })
      }
    })

    return store
  }
}

export default Store
